import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 group cursor-pointer">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={`${article.title} - 大鸡巴品种科普`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50">
              {article.categoryName}
            </span>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-base font-semibold font-heading text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}